
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TransitionSize',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    name: {
      type: String,
    },
    blockWidth: {
      type: Boolean,
    },
    blockHeight: {
      type: Boolean,
    },
    duration: {
      type: String,
      default: 'normal',
    },
    appear: {
      type: Boolean,
    },
    selectedComponent: {
      type: String,
    },
  },
  data() {
    return {
      baseClass: 'epb-transition-size',
    }
  },
  computed: {
    transitionClasses() {
      return {
        enterClass: this.getTransitionClass('enter'),
        enterActiveClass: this.getTransitionClass('enter-active'),
        enterToClass: this.getTransitionClass('enter-to'),
        leaveClass: this.getTransitionClass('leave'),
        leaveActiveClass: this.getTransitionClass('leave-active'),
        leaveToClass: this.getTransitionClass('leave-to'),
      }
    },
    hooks() {
      return {
        enter: this.onEnter,
        afterEnter: this.onAfterEnter,
        leave: this.onLeave,
        afterLeave: this.onAfterLeave,
      }
    },
  },
  methods: {
    getTransitionClass(suffix: string): string {
      let transitionClass = `${this.baseClass}--animated-${this.duration}-${suffix}`

      if (this.name) {
        transitionClass += ` ${this.name}-${suffix}`
      }
      return transitionClass
    },
    onEnter(element: HTMLElement): void {
      const { scrollWidth, scrollHeight } = element
      if (!this.blockWidth) {
        element.style.width = '0'
      }
      if (!this.blockHeight) {
        element.style.height = '0'
      }
      requestAnimationFrame(() => {
        if (!this.blockWidth) {
          element.style.width = `${scrollWidth}px`
        }
        if (!this.blockHeight) {
          element.style.height = `${scrollHeight}px`
        }
      })
    },
    onAfterEnter(element: HTMLElement): void {
      this.resetElement(element)
    },
    resetElement(element: HTMLElement): void {
      if (!this.blockWidth) {
        element.style.removeProperty('width')
      }
      if (!this.blockHeight) {
        element.style.removeProperty('height')
      }
    },
    onLeave(element: HTMLElement): void {
      if (!this.blockWidth) {
        element.style.width = `${element.scrollWidth}px`
      }
      if (!this.blockHeight) {
        element.style.height = `${element.scrollHeight}px`
      }
      requestAnimationFrame(() => {
        if (!this.blockWidth) {
          element.style.width = '0'
        }
        if (!this.blockHeight) {
          element.style.height = '0'
        }
      })
    },
    onAfterLeave(element: HTMLElement): void {
      this.resetElement(element)
    },
  },
})
